import React, { PureComponent } from 'react';
import CheckBox from '../../../../components/svg/CheckBox';
import { getHexColorString, getOpacityFromRgba } from '../../../../helpers/helpers';
import FieldWrapper from './FieldWrapper';
import { checkIfCalculationValueIsTrue } from '../../../helpers';
import { ValueChangedForFieldFunc } from '../../../formeditor-types';

export interface CheckBoxFieldProps {
  valueUpdated?: ValueChangedForFieldFunc;
  id?: string;
  fieldId?: string;
  x?: number;
  y?: number;
  w?: number;
  h?: number;
  align?: string;
  foregroundColor?: TypeMePlease;
  backgroundColor?: TypeMePlease;
  displayType?: number;
  maxSize?: number;
  padding?: number;
  editable?: boolean;
  value?: string;
}

export default class CheckBoxField extends PureComponent<CheckBoxFieldProps, TypeMePlease> {
  constructor(props) {
    super(props);

    this.mouseDown = this.mouseDown.bind(this);
  }

  mouseDown() {
    this.props.valueUpdated({ value: `${!checkIfCalculationValueIsTrue(this.props.value)}` });
  }

  render() {
    let checkbox = null;
    if (checkIfCalculationValueIsTrue(this.props.value)) {
      checkbox = (
        <CheckBox
          maxSize={this.props.maxSize}
          padding={this.props.padding}
          foregroundColor={getHexColorString(this.props.foregroundColor)}
          foregroundColorOpacity={getOpacityFromRgba(this.props.foregroundColor)}
          displayType={this.props.displayType}
          width={this.props.w}
          height={this.props.h}
          align={this.props.align}
        />
      );
    }
    return (
      <FieldWrapper
        onMouseDown={this.mouseDown}
        x={this.props.x}
        y={this.props.y}
        w={this.props.w}
        h={this.props.h}
        backgroundColor={this.props.backgroundColor}
        editable={this.props.editable}
        id={this.props.id}
        fieldId={this.props.fieldId}
      >
        {checkbox}
      </FieldWrapper>
    );
  }
}
